import React from 'react';

import {StyledScrollView} from 'components/Styled';
import {
  OfferFilterListItemInterface,
  OfferFiltersDestination,
  OfferFiltersProperty,
} from 'models/OfferFilters';

import OfferFilterListItem from './Item';

export interface OfferFilterListProps {
  list: OfferFiltersDestination[] | OfferFiltersProperty[];
  onSelect?: (item: OfferFilterListItemInterface) => () => void;
  isSelected?: (item: OfferFilterListItemInterface) => boolean;
  hasAllOption?: boolean;
  allSelected?: boolean;
  onSelectAll?: () => void;
  setBottomBorder?: boolean;
  isModal?: boolean;
  availableProperties?: string[];
  offersCount?: {[key: string]: number};
  isPropertyList?: boolean;
}

const OfferFilterList: React.FC<OfferFilterListProps> = ({
  list,
  onSelect,
  isSelected,
  hasAllOption,
  allSelected,
  onSelectAll,
  setBottomBorder = false,
  isModal = false,
  availableProperties,
  offersCount,
  isPropertyList = false,
}) => {
  const isDestinationOrPropertyDisabled = item => {
    // check if item is of type Destination
    if (item.properties) {
      const properties = item.properties.filter(
        property => availableProperties?.includes(property.id.toUpperCase())
      );
      return properties.length < 1;
    }
    // if item is of type Property
    return !availableProperties?.includes(item.id.toUpperCase());
  };

  const filterByDisable = list.filter(isDestinationOrPropertyDisabled);
  const filterByAvailable = list.filter(
    item => !isDestinationOrPropertyDisabled(item)
  );
  const sortedList = [...filterByAvailable, ...filterByDisable];

  return (
    <StyledScrollView
      testID="filter-list"
      marginX={!isModal ? 4 : undefined}
      maxHeight={!isModal ? '250px' : undefined}>
      {hasAllOption && list.length > 1 && (
        <OfferFilterListItem
          active={allSelected}
          chevronDisabled={isPropertyList}
          disabled={false}
          onPress={onSelectAll}
          setBottomBorder={setBottomBorder}
          title="All Hotels & Resorts"
        />
      )}
      {(sortedList || []).map((item, idx, array) => {
        return (
          <OfferFilterListItem
            active={isSelected && isSelected(item)}
            chevronDisabled={isPropertyList}
            count={offersCount ? offersCount[item.id] : undefined}
            disabled={isDestinationOrPropertyDisabled(item)}
            key={item.id}
            onPress={onSelect && onSelect(item)}
            setBottomBorder={array.length - 1 === idx ? false : setBottomBorder}
            title={item.name}
          />
        );
      })}
    </StyledScrollView>
  );
};

export default OfferFilterList;
